module.exports = __webpack_public_path__ + "static/wiz3a-4cc9cf0264f0ab3f4688eb80fd75f7db.jpg";